
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[articleID]",
      function () {
        return require("private-next-pages/articles/[articleID].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[articleID]"])
      });
    }
  